import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

import { IconLibrary } from '@galabid/gb-dashboard/shared/ui'
import { StaffFacade, StaffReportTypeEnum } from '@galabid/gb-dashboard/staff/data-access'
import { TranslateService } from '@ngx-translate/core'
import { GbBreakpointService } from 'libs/gb-dashboard/shared/utils/src/lib/gb-breakpoint-service/gb-breakpoint.service'
import * as StaffActions from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.actions'
import { GbValidators } from 'libs/shared/utils/helpers/src/lib/gb-validators/gb-validators'
import moment from 'moment'

export interface GbStaffReportsDownloadDialogData {
  staffReportType: StaffReportTypeEnum
  dialogTitle: string
}

@Component({
  selector: 'gb-staff-reports-download-dialog',
  templateUrl: './gb-staff-reports-download-dialog.component.html',
  styleUrls: ['./gb-staff-reports-download-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbStaffReportsDownloadDialogComponent {
  protected readonly IconLibrary = IconLibrary
  exportReportLoaded$ = this.staffFacade.exportReportLoaded$
  dialogTitle = this.translateService.instant('STAFF.SELECT_DATE_RANGE')
  today = new Date()
  isMobileOrTabletDevice$ = this.gbBreakpointService.isMobileOrTabletDevice$

  startDate = new FormControl<Date>(new Date(new Date().setMonth(this.today.getMonth() - 1)), {
    validators: [Validators.required],
  })
  endDate = new FormControl<Date>(new Date(), { validators: [Validators.required] })
  formDateRange = new FormGroup(
    { startDate: this.startDate, endDate: this.endDate },
    { validators: [GbValidators.dateAfter('startDate', 'endDate')] },
  )

  constructor(
    private staffFacade: StaffFacade,
    private gbBreakpointService: GbBreakpointService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: GbStaffReportsDownloadDialogData,
  ) {
    this.dialogTitle = data.dialogTitle
  }

  onSubmit() {
    this.formDateRange.invalid ? this.formDateRange.markAllAsTouched() : this.exportStaffReport()
  }

  exportStaffReport() {
    const startDate = moment(this.startDate.value).format('DD/MM/YYYY')
    const endDate = moment(this.endDate.value).format('DD/MM/YYYY')
    if (startDate && endDate) {
      if (this.data.staffReportType === StaffReportTypeEnum.Vouchers) {
        this.staffFacade.dispatch(
          StaffActions.exportVoucherReport({
            startDate: startDate,
            endDate: endDate,
          }),
        )
      } else {
        this.staffFacade.dispatch(
          StaffActions.exportStaffReport({
            staffReportType: this.data.staffReportType,
            startDate: startDate,
            endDate: endDate,
          }),
        )
      }
    }
  }

  isStartDateRequired(): boolean {
    return this.startDate.hasError('required') && Object.keys(this.startDate.errors!).length === 1
  }
  isEndDateRequired(): boolean {
    return this.endDate.hasError('required') && Object.keys(this.endDate.errors!).length === 1
  }
}
